export default "__VITE_ASSET__BvuQv2Mm__"